/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentBookingState/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Cancelled from './Cancelled/index'
import CheckedOut from './CheckedOut/index'
import Confirmed from './Confirmed/index'
import No from './No/index'
import NoShow from './NoShow/index'
import React from 'react'
import Scheduled from './Scheduled/index'
import Unseated from './Unseated/index'



/** @type {import('Simple/types.js').View} */
export default function AppointmentBookingState({
  children,
  viewPath = "/DesignSystem/AppointmentBookingState"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedStateValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'state',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedStateValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Scheduled'}>
<Scheduled
  viewPath={`${viewPath}/Scheduled`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Confirmed'}>
<Confirmed
  viewPath={`${viewPath}/Confirmed`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Cancelled'}>
<Cancelled
  viewPath={`${viewPath}/Cancelled`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NoShow'}>
<NoShow
  viewPath={`${viewPath}/NoShow`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Unseated'}>
<Unseated
  viewPath={`${viewPath}/Unseated`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckedOut'}>
<CheckedOut
  viewPath={`${viewPath}/CheckedOut`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}